import {
  Box,
  Flex,
  Heading,
  Image,
  Link,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Button } from "~/components/Buttons";
import { useNavbarHeight } from "~/lib/hooks";
import { Subheading } from "../Text";

export const FifthPanel = () => {
  return (
    <Box
      backgroundColor="white"
      position="relative"
      bgImg="/MapTexture.png"
      backgroundSize="cover"
      py={{ base: 8, lg: 16 }}
    >
      <Flex position="relative" zIndex={1} alignItems="center" flexWrap="wrap">
        <Box
          w={{ base: "100%", lg: "60%" }}
          pr={{ base: 4, md: 0 }}
          pl={{ base: 4, md: 8, lg: 16 }}
          py={{ base: 4, md: 0 }}
        >
          <Image src="/hwy3-map.png" alt="" w="100%" h="auto" />
        </Box>

        <Box
          w={{ base: "100%", lg: "40%" }}
          px={{ base: "40px", md: 8, lg: 16 }}
          py={{ base: 4, md: 8, lg: 16 }}
          textAlign="center"
        >
          <Box maxW={{ base: "100%", sm: "475px" }} mx="auto">
            <Heading
              fontSize={{ base: "6xl", md: "8xl", lg: "6xl" }}
              mb={{ base: "18px", md: "48px" }}
            >
              <Box color="green.500">Discover</Box>
              <Box fontWeight="thin">the heart of Highway&nbsp;3</Box>
            </Heading>

            <Subheading
              as="p"
              fontSize={{ base: "lg", md: "2xl" }}
              mb={{ base: "24px", lg: "72px" }}
            >
              Explore the communities along the route
            </Subheading>

            <Button
              as={Link}
              href="/map"
              backgroundColor="yellow.500"
              color="gray.900"
            >
              View Map
            </Button>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

FifthPanel.displayName = "SwiperSlideFifthPanel";
